"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _react2 = require("@emotion/react");

var _util = require("../util");

var useColor = function useColor(color) {
  var theme = (0, _react2.useTheme)();
  return (0, _react.useMemo)(function () {
    return (0, _util.themeValLookup)(color)({
      theme: theme
    }) || color;
  }, [color, theme]);
};

var _default = useColor;
exports["default"] = _default;
//# sourceMappingURL=useColor.js.map